import { render } from "./QuestionnaireAnswerSection.vue?vue&type=template&id=6f9058de&scoped=true&ts=true"
import script from "./QuestionnaireAnswerSection.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireAnswerSection.vue?vue&type=script&lang=ts"

import "./QuestionnaireAnswerSection.vue?vue&type=style&index=0&id=6f9058de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9058de"]])

export default __exports__